import type { TrackedTranslation } from '@ps/web-core-intl';
import { minLength, required } from '@ps/web-shared-validators';

export const getFieldValidation = (minFieldLength: number, translation: TrackedTranslation) => [
  required({ ...translation }),
  minLength(minFieldLength, { ...translation })
];
